<template>
  <WidgetVue
  :title="title"
  :desc="desc"
  class="chart"
  >
  <canvas ref="lineChart"></canvas>

  </WidgetVue>
</template>
<script>
import { Chart } from "chart.js/auto";
import WidgetVue from "@/components/WidgetVue.vue"
export default {
  components:{
    WidgetVue
  },
  props: {
    datum: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    desc: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      rawValues: null,
      chartValues: null,
    };
  },
  mounted() {
    this.chartValues = this.calculateAverageScores(this.datum.df);
    this.createChart(
      this.chartValues.X,
      this.chartValues.Y
    );
  },
  beforeUnmount() {
    // Destroy the chart instance when the component is destroyed to avoid memory leaks
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    adjustSeries(x, y) {
      const targetLength = 8;

      if (x.length >= targetLength) {
        return { 'X': x, 'Y': y };
      }

      const minYear = Math.min(...x);
      const missingYears = Array.from({ length: targetLength - x.length }, (_, index) => minYear - index - 1);

      const adjustedX = [...missingYears.reverse(), ...x];
      const adjustedY = Array.from({ length: targetLength - x.length }).fill(0).concat(y);

      return { 'X': adjustedX, 'Y': adjustedY };
    },

    calculateAverageScores(data) {
      const averageScores = {};

      data.forEach((entry) => {
        const year = entry.year;
        const sentscore = entry.sentscore;

        if (!averageScores[year]) {
          averageScores[year] = { sum: 0, count: 0 };
        }

        averageScores[year].sum += sentscore * 100;
        averageScores[year].count += 1;
      });

      const results = Object.entries(averageScores).map(
        ([year, { sum, count }]) => ({
          year: parseInt(year),
          averageSentiscore: (sum / count).toFixed(2),
        })
      );

      // When there is less then 8 data point add more for X
      let X = results.map((item) => item.year);
      let Y = results.map((item) => item.averageSentiscore);
      
      this.rawValues ={
        'X': X, 'Y':Y
      }

      let adjustedSeries = this.adjustSeries(X,Y)

      return {
        'X': adjustedSeries.X,
        'Y': adjustedSeries.Y,
      };
    },
    createChart(X, Y) {
      const ctx = this.$refs.lineChart.getContext("2d");
      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: X,
          datasets: [
            {
              label: "Average Sentiscore",
              data: Y,
              borderColor: "blue",
              borderWidth: 2,
              pointRadius: 5,
              pointBackgroundColor: "violet",
              fill: false,
            },
          ],
        },
        options: {
          scales: {
            x: {
              type: "linear",
              position: "bottom",
              ticks: {
                callback: function (value) {
                  // Format the X-axis labels as integers
                  return parseInt(value);
                },
              },
            },
            y: {
              beginAtZero: false,
            },
          },
        },
      });
    },
  },
};
</script>
